import { inputClasses, selectClasses, textareaClasses } from "./inputClasses.js";
import { computed, toValue } from "vue";
const defaults = {
  size: "md",
  errorMsg: "",
  required: false,
  prefix: false,
  suffix: false,
  rounded: false
};
function useInputClasses(props) {
  const opts = computed(() => {
    const propsValue = toValue(props);
    return { ...defaults, ...propsValue, error: !!propsValue.errorMsg };
  });
  const allClasses = computed(() => {
    const { input, label, errorMessage } = inputClasses(opts.value);
    return { input: input(), label: label(), errorMessage: errorMessage() };
  });
  const inputClasses$1 = computed(() => allClasses.value.input);
  const labelClasses = computed(() => allClasses.value.label);
  const errorMsgClasses = computed(() => allClasses.value.errorMessage);
  const selectClasses$1 = computed(() => {
    const { input } = selectClasses(opts.value);
    return input();
  });
  const textareaClasses$1 = computed(() => {
    const { input } = textareaClasses(opts.value);
    return input();
  });
  return {
    inputClasses: inputClasses$1,
    labelClasses,
    selectClasses: selectClasses$1,
    textareaClasses: textareaClasses$1,
    errorMsgClasses
  };
}
export {
  useInputClasses
};
